import { render, staticRenderFns } from "./tabulator-report-table.vue?vue&type=template&id=9a4c85a8&"
import script from "./tabulator-report-table.vue?vue&type=script&lang=js&"
export * from "./tabulator-report-table.vue?vue&type=script&lang=js&"
import style0 from "./tabulator-report-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports